export default "__VITE_ASSET__CHKXGcvb__"